import { Injectable } from '@angular/core';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageUtils } from '../../util/article-usage-utils';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { ReplaceDynamicArticleUtils } from './replace-dynamic-article-utils';

@Injectable({
  providedIn: 'root'
})
export class ReplaceDynamicArticleService {

  constructor(private containerService: ContainerService) { }

  public getBackwardUsageIdsByCheckFunction(articleContainer: ArticleContainer, isArticleOnRailCheck: (article: ArticleContainer) => boolean, foundUsageIds: string[] = []): string[] {
    const backwardIds: string[] = ArticleUsageUtils.getBackwardConnectedArticleUsageIds(articleContainer.articleUsage);
    for (const backwardId of backwardIds) {
      const backwardContainer: ArticleContainer = this.containerService.findArticleContainerInGlobal(backwardId);
      if (isArticleOnRailCheck(backwardContainer)) {
        if (foundUsageIds.indexOf(backwardId) === -1) {
          foundUsageIds.push(backwardId);
        }
      } else {
        foundUsageIds = this.getBackwardUsageIdsByCheckFunction(backwardContainer, isArticleOnRailCheck, foundUsageIds);
      }
    }
    return foundUsageIds;
  }

  public getBackwardUsageIdsConnectedToAcceptingId(articleContainer: ArticleContainer, acceptingId: MetaElementUsageIdentityVO): string[] {
    return this.getBackwardUsageIdsByCheckFunction(articleContainer,
      (container: ArticleContainer) => ReplaceDynamicArticleUtils.isArticleConnectedToAcceptingId(container, acceptingId));
  }
}
